var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-ios-information-circle",
    "data-name": "Icon ionic-ios-information-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.625,
    height: 14.625,
    viewBox: "0 0 14.625 14.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-information-circle-2",
    "data-name": "Icon ionic-ios-information-circle",
    d: "M10.688,3.375A7.313,7.313,0,1,0,18,10.688,7.311,7.311,0,0,0,10.688,3.375Zm.668,10.688H10.012V9h1.343Zm-.671-5.618a.7.7,0,1,1,.728-.7A.7.7,0,0,1,10.684,8.445Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#962cc6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcon);
export default __webpack_public_path__ + "static/media/i-icon.071075bcc8d0a8816a147a5ff3d78d82.svg";
export { ForwardRef as ReactComponent };